import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { AvailabilityEffects } from './availability.effects';
import { ShopsAvailableEffects } from './shops-available.effects';

export const effects: any[] = [AvailabilityEffects, ShopsAvailableEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
})
export class AvailabilityEffectsModule {}
